"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNumberFormat = require("react-number-format");

var _material = require("@mui/material");

var _excluded = ["onChange"],
    _excluded2 = ["onChange"],
    _excluded3 = ["isNumericFormat", "errorText", "className", "style", "InputProps", "inputProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NumericFormatCustom = /*#__PURE__*/_react["default"].forwardRef(function NumericFormatCustom( // eslint-disable-line
props, ref) {
  var onChange = props.onChange,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.NumericFormat, _extends({
    valueIsNumericString: true
  }, other, {
    getInputRef: ref,
    onValueChange: onChange
  }));
});

NumericFormatCustom.propTypes = {
  onChange: _propTypes["default"].func.isRequired
};

var PatternFormatCustom = /*#__PURE__*/_react["default"].forwardRef(function PatternFormatCustom( // eslint-disable-line
props, ref) {
  var onChange = props.onChange,
      other = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, _extends({}, other, {
    getInputRef: ref,
    onValueChange: onChange
  }));
});

PatternFormatCustom.propTypes = {
  onChange: _propTypes["default"].func.isRequired
};

var BaseNumberInput = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseNumberInput, _React$Component);

  var _super = _createSuper(BaseNumberInput);

  function BaseNumberInput() {
    _classCallCheck(this, BaseNumberInput);

    return _super.apply(this, arguments);
  }

  _createClass(BaseNumberInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isNumericFormat = _this$props.isNumericFormat,
          errorText = _this$props.errorText,
          className = _this$props.className,
          style = _this$props.style,
          InputProps = _this$props.InputProps,
          inputProps = _this$props.inputProps,
          etc = _objectWithoutProperties(_this$props, _excluded3);

      return /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({
        className: className,
        error: Boolean(errorText),
        helperText: errorText,
        style: style,
        InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
          inputComponent: isNumericFormat ? NumericFormatCustom : PatternFormatCustom
        }),
        inputProps: inputProps
      }, etc));
    }
  }], [{
    key: "extendProps",
    value: function extendProps(componentClass) {
      componentClass.propTypes = _objectSpread(_objectSpread({}, BaseNumberInput.propTypes), componentClass.propTypes);
      componentClass.defaultProps = _objectSpread(_objectSpread({}, BaseNumberInput.defaultProps), componentClass.defaultProps);
    }
  }]);

  return BaseNumberInput;
}(_react["default"].Component);

exports["default"] = BaseNumberInput;

_defineProperty(BaseNumberInput, "propTypes", _objectSpread(_objectSpread(_objectSpread({}, _reactNumberFormat.NumericFormat.propTypes), _reactNumberFormat.PatternFormat.propTypes), {}, {
  errorText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  inputProps: _propTypes["default"].object
}));

_defineProperty(BaseNumberInput, "defaultProps", {
  errorText: '',
  className: '',
  isintl: 'false',
  isNumericFormat: true
});